import {
  SyntheticEvent, useCallback, useState, useEffect,
} from 'react';
import { IListItem } from 'components/common/CollapsableList/type';
import ListItem from 'components/common/CollapsableList/components/ListItem';

import styles from './styles.module.scss';

interface IProps {
  data: Array<IListItem>,
  isFirstOpenByDefault?: boolean,
}

export const CollapsableList = ({ data, isFirstOpenByDefault }: IProps) => {
  const [expandedKey, setExpandedKey] = useState<string | undefined>(undefined);

  const onClick = useCallback((event: SyntheticEvent<HTMLDivElement>) => {
    const { id } = event.currentTarget.dataset;
    const currentKey = expandedKey === id ? undefined : id;

    setExpandedKey(currentKey);
  }, [setExpandedKey, expandedKey]);

  useEffect(() => {
    if (isFirstOpenByDefault && !expandedKey) {
      setExpandedKey(data[0]?.title);
    }
  }, [data, isFirstOpenByDefault]);

  return (
    <div className={styles.container}>
      {data.map((item) => (
        <ListItem
          key={item.title}
          handleClick={onClick}
          title={item.title}
          description={item.description}
          isActive={item.title === expandedKey}
        />
      ))}
    </div>
  );
};
